import { Pagination } from "../../../../model/pagination";
import HttpClient from "../../../services/http-client";
import { IPurchasePageRequest } from "../../../../model/scp/purchase/request/purchase-paged-request";
import { IPurchasePagedResponse } from "../../../../model/scp/purchase/response/purchase-paged-response";
import { serialize } from "object-to-formdata";
import { IPurchaseAddEditRequest } from "../../../../model/scp/purchase/request/purchase-add-edit-request";
import { IItemPurchaseAddEditRequest } from "../../../../model/scp/purchase/request/purchase-item-add-edit-request";
import { IPurchaseResponse } from "../../../../model/scp/purchase/response/purchase-response";
import { IPurchaseItemPageRequest } from "../../../../model/scp/purchase/request/purchase-item-paged-request";
import { IPurchaseItemResponse } from "../../../../model/scp/purchase/response/purchase-item-response";
import { IFilePageRequest } from "../../../../model/scp/base/request/file-paged-request";
import { IFileResponse } from "../../../../model/scp/base/response/file-response";
import { IFileAddRequest } from "../../../../model/scp/base/request/file-add-request";
import { IGetPurchaseItemResultRequest } from "../../../../model/scp/purchase-item-result/request/get-purchase-item-result-request";
import { IPurchaseItemResultResponse } from "../../../../model/scp/purchase-item-result/response/purchase-item-result-response";
import { IAddPurchaseItemResultRequest } from "../../../../model/scp/purchase-item-result/request/add-purchase-item-result-request";
import { IUpdatePurchaseItemResultRequest } from "../../../../model/scp/purchase-item-result/request/update-purchase-item-result-request";

const defaultPath = 'Purchase';

const listPurchase = async (params: IPurchasePageRequest): Promise<Pagination<IPurchasePagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: params
    }).then((response) => Object.assign(new Pagination<IPurchasePagedResponse>(), response.data));
};

const listAllPurchase = async (): Promise<IPurchasePagedResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/All`,
    }).then((response) => Object.assign([] as unknown as IPurchasePagedResponse, response.data));
};


const listPurchaseItems = async (params: IPurchaseItemPageRequest): Promise<Pagination<IPurchaseItemResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${params.id}/Items`,
        params: { page: params.page, pageSize: params.pageSize }
    }).then((response) => Object.assign(new Pagination<IPurchaseItemResponse>(), response.data));
};


const listPurchaseFiles = async (params: IFilePageRequest): Promise<Pagination<IFileResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${params.id}/Files`,
        params: { page: params.page, pageSize: params.pageSize }
    }).then((response) => Object.assign(new Pagination<IFileResponse>(), response.data));
};


const addItemsPurchase = async (id: number, params: IItemPurchaseAddEditRequest[]) => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${id}/Items`,
        data: { items: params }
    });
};
const updateItemPurchase = async (id: number, number: number, params: IItemPurchaseAddEditRequest) => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}/Items/${number}`,
        data: params
    });
};


const getPurchase = async (id: number): Promise<IPurchaseResponse> => {

    return await HttpClient.executeRequest({

        method: 'get',
        url: `/${defaultPath}/${id}`,
    }).then((response) => Object.assign({} as IPurchaseResponse, response.data));
};
const deletePurchase = async (justification: string, id: number) => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`,
        params: { justification }
    });
}
const updatePurchase = async (id: number, params: IPurchaseAddEditRequest) => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params,
    });
}
const addPurchase = async (params: IPurchaseAddEditRequest, file: File, items: string) => {
    const formData = serialize({ ...params, items }, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    formData.append("document", file);

    // A API devolve o registro criado; o id leva o usuário à edição para anexar documentos
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }).then((response) => Object.assign({} as IPurchaseResponse, response.data));
};


const addFilePurchase = async (params: IFileAddRequest) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${params.id}/Files`,
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};
const deleeteFilePurchase = async (justification: string, id: number, number: number) => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}/Files/${number}`,
        params: { justification }
    });
}

const getPurchaseItemResult = async (params: IGetPurchaseItemResultRequest): Promise<IPurchaseItemResultResponse | null> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${params.purchaseId}/Items/${params.itemNumber}/Results/${params.resultSequence}`,
    }).then((response) => {
        if (response.data === null || response.data === undefined || Object.keys(response.data).length === 0) return null;
        return Object.assign({} as IPurchaseItemResultResponse, response.data);
    });
};

const addPurchaseItemResult = async (purchaseId: number, itemNumber: number, params: IAddPurchaseItemResultRequest) => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${purchaseId}/Items/${itemNumber}/Results`,
        data: params
    });
};

const updatePurchaseItemResult = async (purchaseId: number, itemNumber: number, resultSequence: number, params: IUpdatePurchaseItemResultRequest) => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${purchaseId}/Items/${itemNumber}/Results/${resultSequence}`,
        data: params
    });
};
const PurchaseAppService = {
    listPurchase, addPurchase, deletePurchase, getPurchase, listAllPurchase, updatePurchase, listPurchaseItems, addItemsPurchase, updateItemPurchase, listPurchaseFiles, addFilePurchase, deleeteFilePurchase, getPurchaseItemResult, addPurchaseItemResult, updatePurchaseItemResult
};

export default PurchaseAppService;